import { Navigate, useNavigate } from "react-router-dom";
import { Lock, TrendingUp, Users, Wallet } from "lucide-react";

import hero from "@/assets/hero.jpg";
import { useAuth } from "@/lib/auth";
import { Brand } from "@/components/brand";
import { Button, Loading } from "@/components/kit";

const POINTS = [
  { icon: Users, text: "Recommandez vos clients en quelques secondes" },
  { icon: TrendingUp, text: "Suivez chaque dossier jusqu'à la signature" },
  { icon: Wallet, text: "Touchez vos commissions et récompenses" },
];

export function Index() {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen"><Loading /></div>;
  if (user === false) return <Navigate to="/welcome" replace />;
  return <Navigate to={user.role === "admin" ? "/admin-home" : "/home"} replace />;
}

export default function Welcome() {
  const navigate = useNavigate();
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return (
    <div data-testid="welcome-screen" className="relative min-h-screen overflow-hidden bg-[#121212]">
      <img src={hero} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(18,18,18,0.35)_0%,rgba(18,18,18,0.85)_45%,#121212_80%)] lg:bg-[linear-gradient(90deg,#121212_0%,rgba(18,18,18,0.92)_42%,rgba(18,18,18,0.35)_100%)]" />
      <div className="relative mx-auto flex min-h-screen max-w-6xl flex-col px-6 py-6 md:px-10 md:py-10">
        <div className="fade-up">
          <Brand />
        </div>
        <div className="flex-1" />
        <div className="flex max-w-2xl flex-col gap-4 fade-up" style={{ animationDelay: "150ms" }}>
          <h1 className="t-display md:!text-[44px] md:!leading-[52px]">Plateforme nationale de recommandations immobilières</h1>
          <p className="t-body !text-[#C0C0C0] md:!text-base">
            Agents immobiliers, mandataires et agences : recommandez vos clients ayant un projet de construction ou de rénovation et gagnez des commissions.
          </p>
          <ul className="my-2 flex flex-col gap-3">
            {POINTS.map((p) => (
              <li key={p.text} className="flex items-center gap-3">
                <p.icon className="h-5 w-5 text-[#D4AF37]" aria-hidden />
                <span className="text-sm text-white">{p.text}</span>
              </li>
            ))}
          </ul>
          <div className="flex flex-col gap-3 md:flex-row">
            <Button testID="welcome-register-button" title="Créer mon compte partenaire" size="lg" className="md:flex-1" onClick={() => navigate("/register")} />
            <Button testID="welcome-login-button" title="J'ai déjà un compte" variant="secondary" size="lg" className="md:flex-1" onClick={() => navigate("/login")} />
          </div>
          <Button testID="welcome-admin-button" title="Espace gérant" icon={Lock} variant="ghost" className="md:w-fit" onClick={() => navigate("/admin-login")} />
        </div>
      </div>
    </div>
  );
}
